export default
`
An individual and/or their family members may refuse to admit that they have the condition.\r\n
 
In this piece Patrica has taken inspiration from the 1918 human anatomy textbook, Gray’s anatomy.\r\n
 
The woman’s face is turned away in a look of denial. Underneath the skin of the neck and lower brain (artistic interpretation) is revealed to highlight the individual’s vulnerability.  Across the top of the brain is a mathematical simulation of an electroencephalogram (EEG) reading during a seizure to represent that the condition is ongoing regardless of denial.\r\n
 
An EEG is a routine test used in the diagnosis of epilepsy. Sensors are placed across the scalp to record electrical brain activity. The simulation was constructed by Dr Junges who constructs mathematical and computational models from clinical EEG data to make predictions about seizures e.g. their location in the brain. Using this method, researchers can make virtual representations of the epileptic brain to test hypotheses that would not be possible to test in a living brain, e.g., different surgery strategies.\r\n

`


// WEBPACK FOOTER //
// ./src/content/denial.js